<div *ngIf="isLoading" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container m-t-30">
  <div class="header-container">
    <div>
      <mat-form-field class="filter-form-field">
        <mat-label>Search for data by ID number</mat-label>
        <input matInput type="text"
               [formControl]="policyProductPersonIdNumberSearchFormControl"
               (input)="onInputChangedSearchPolicyProductPersonData($event, tableColumns.NationalIdNumber)">
      </mat-form-field>
      <mat-form-field class="filter-form-field" style="margin-left: 24px">
        <mat-label>Search for data by policy number</mat-label>
        <input matInput type="text"
               [formControl]="policyProductPersonPolicyNumberSearchFormControl"
               (input)="onInputChangedSearchPolicyProductPersonData($event, tableColumns.PolicyNumber)">
      </mat-form-field>
    </div>
  </div>
  
  <label class="mat-primary-color font-small">Hint: click on a row to expand more information</label>
  
  <div *ngIf="policyProductPersonDataSource" class="mat-elevation-z8 table-container">
    <table mat-table multiTemplateDataRows [dataSource]="policyProductPersonDataSource"
           #policyProductPersonDataSort="matSort" matSort
           (matSortChange)="sortData($event)">
      
      <ng-container [matColumnDef]="tableColumns.Created">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
        <td style="width: 350px" *matCellDef="let row" mat-cell>{{row.created | date: dateTimeFormat}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.IsImported">
        <th *matHeaderCellDef mat-header-cell>Imported?
          <mat-icon style="font-size: small; text-align: center" [matTooltip]="infoTooltipImportedColumn">help_outline
          </mat-icon>
        </th>
        <td style="width: 350px; text-align: center" *matCellDef="let row" mat-cell>{{row.isImported}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.NationalIdNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID Number</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.nationalIdNumber}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.LastName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Full Name</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.lastName}}
          , {{row.firstName}} {{row.middleName}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Gender">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Gender</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.gender}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.DateOfBirth">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Birth Date</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.dateOfBirth}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Association">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Association</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.association}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.ProductCode">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Product Code</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.productCode}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.PolicyNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Number</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.policyNumber}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.PolicyName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Name</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.policyName}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.PolicyStartDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Dates</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.policyStartDate}} - {{row.policyEndDate}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.CoverStatusStartDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Cover Dates</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.coverStatusStartDate}}
          - {{row.coverStatusEndDate}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.CoverStatus">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Cover Status</th>
        <td style="width: 350px;" *matCellDef="let row" mat-cell>{{row.coverStatus}}</td>
      </ng-container>
      
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" mat-cell [attr.colspan]="policyProductPersonDataDisplayedColumns.length">
          <div class="row-detail-container"
               [@detailExpand]="row == policyProductPersonDataExpandedRow ? 'expanded' : 'collapsed'">
            <b>Card Number: </b>{{row.cardNumber}}<br>
            <b>External ID: </b>{{row.externalId}}<br>
            <b>External Policy Number: </b>{{row.policyNumberExternal}}<br>
            <b>Title: </b>{{row.title}}<br>
            <b>Designation: </b>{{row.designation}}<br>
            <b>Marital Status: </b>{{row.maritalStatus}}<br>
            <b>Associated Person ID Number: </b>{{row.associatedInsuredPersonNationalIdNumber}}<br>
            <b>Nominated Beneficiary ID Number: </b>{{row.nominatedBeneficiaryNationalIdNumber}}<br>
            <b>Nationality: </b>{{row.countryOfNationality}}<br>
            <b>Passport Number: </b>{{row.passportNumber}}<br>
            <b>Language: </b>{{row.language}}<br>
            <b>Address Line 1: </b>{{row.addressLine1}}<br>
            <b>Address Line 2: </b>{{row.addressLine2}}<br>
            <b>Suburb: </b>{{row.suburb}}<br>
            <b>City: </b>{{row.city}}<br>
            <b>Province: </b>{{row.province}}<br>
            <b>Postal Code: </b>{{row.postalCode}}<br>
            <b>Email: </b>{{row.email}}<br>
            <b>Mobile: </b>{{row.mobileNumber}}<br>
            <b>Landline: </b>{{row.landlineNumber}}<br>
            <b>Preferred Contact Method: </b>{{row.preferredContactMethod}}<br>
            <b>Policy Activation Date: </b>{{row.policyActivationDate}}<br>
            <b>Policy Application Date: </b>{{row.policyApplicationDate}}<br>
            <b>Policyholder Number: </b>{{row.policyHolderNumber}}<br>
            <b>Policyholder Name: </b>{{row.policyholderName}}<br>
            <b>Policyholder Group Number: </b>{{row.policyholderGroupNumber}}<br>
            <b>Policyholder Group Name: </b>{{row.policyholderGroupName}}<br>
            <b>Entity Status: </b>{{row.entityStatus}}<br>
            <b>Entity Dates: </b>{{row.entityStatusStartDate}} - {{row.entityStatusEndDate}}<br>
            <b>Has Endorsements: </b>{{row.hasEndorsements}}<br>
            <b>Product Waivers: </b>{{row.productWaiverList}}<br>
            <b>Product Variances: </b>{{row.productVarianceList}}<br>
            <b>Pre Existing Conditions: </b>{{row.preExistingConditionList}}<br>
            <b>Card History: </b>{{row.cardHistoryList}}<br>
            <b>Exclusions: </b>{{row.exclusionList}}<br>
          </div>
        </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="policyProductPersonDataDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: policyProductPersonDataDisplayedColumns;"
          class="row" [class.expanded-row]="policyProductPersonDataExpandedRow == row"
          (click)="policyProductPersonDataExpandedRow = policyProductPersonDataExpandedRow === row ? null : row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
    
    </table>
    
    <mat-paginator #policyProductPersonDataPaginator
                   [length]="policyProductPersonDataTableControl.length"
                   [pageSize]="policyProductPersonDataTableControl.pageSize" [pageIndex]="0"
                   [pageSizeOptions]="policyProductPersonDataTableControl.pageSizeOptions"
                   (page)="pageChanged($event)">
    </mat-paginator>
  
  </div>
</div>
